import { Link, useLocation } from "react-router-dom";
import { LOCALES, LOCALE_FLAG, LOCALE_LABEL, localeFromPath } from "@/i18n/config";
import { translateLocalizedPath } from "@/seo";
import "./LanguageSwitcher.css";

/**
 * Selector de idioma.
 *
 * Son <Link> reales y no botones: cada idioma es una URL distinta, asi que
 * tiene que poder abrirse en otra pestaña, copiarse y ser rastreable. Un
 * onClick con navegacion programatica rompe las tres cosas.
 *
 * Lleva a la MISMA pagina en el otro idioma, no a la home.
 *
 * Sobre las banderas: representan paises, no idiomas, asi que nunca van solas.
 * Cada una va con el codigo del idioma visible al lado y un aria-label que lo
 * dice con todas las letras.
 */
function LanguageSwitcher({ onNavigate }: { onNavigate?: () => void }) {
  const { pathname } = useLocation();
  const current = localeFromPath(pathname);

  return (
    <div className="lang-switcher" role="group" aria-label="Idioma / Language">
      {LOCALES.map((locale) => {
        const active = locale === current;

        return (
          <Link
            key={locale}
            to={translateLocalizedPath(pathname, locale)}
            className={`lang-switcher__option ${active ? "is-active" : ""}`}
            hrefLang={locale}
            aria-current={active ? "true" : undefined}
            aria-label={LOCALE_LABEL[locale]}
            title={LOCALE_LABEL[locale]}
            onClick={onNavigate}
          >
            <span className="lang-switcher__flag" aria-hidden="true">
              {LOCALE_FLAG[locale]}
            </span>
            <span className="lang-switcher__code">{locale.toUpperCase()}</span>
          </Link>
        );
      })}
    </div>
  );
}

export default LanguageSwitcher;
